import { buildReducer } from '../../../shared';
import type { ContactFoldersLoadingState } from '../../state/view/contactFoldersLoadingState';
import {
    deleteFolderCompletedAction,
    deleteFolderClickedAction,
    confirmDeleteFolderClickedAction,
    cancelDeleteFolderClickedAction,
    renameFolderCompletedAction,
    renameFolderEnteredAction,
    hardDeleteFolderCompletedAction,
    hardDeleteFolderClickedAction,
    confirmHardDeleteFolderClickedAction,
    cancelHardDeleteFolderClickedAction,
} from '../../../appchrome';

const defaultState: ContactFoldersLoadingState = {
    contactFoldersBeingDeleted: [],
    folderIdToDelete: undefined,
    folderIdToHardDelete: undefined,
    beingRenamedFolders: [],
};

/**
 * Keeps track of folders being deleted
 */
export default buildReducer<ContactFoldersLoadingState>()
    .handle(deleteFolderClickedAction, (state, action) => ({
        ...state,
        folderIdToDelete: action.payload.folderId,
    }))
    .handle(confirmDeleteFolderClickedAction, (state, action) => ({
        ...state,
        folderIdToDelete: undefined,
        contactFoldersBeingDeleted: [...state.contactFoldersBeingDeleted, action.payload.folderId],
    }))
    .handle(cancelDeleteFolderClickedAction, (state, action) => ({
        ...state,
        folderIdToDelete: undefined,
    }))
    .handleDataAction(
        deleteFolderCompletedAction,
        (state, action) => ({
            ...state,
            contactFoldersBeingDeleted: state.contactFoldersBeingDeleted.filter(
                folderId => folderId !== action.payload.folderId
            ),
        }),
        (state, action) => ({
            ...state,
            contactFoldersBeingDeleted: state.contactFoldersBeingDeleted.filter(
                folderId => folderId !== action.payload.folderId
            ),
        })
    )
    .handle(hardDeleteFolderClickedAction, (state, action) => ({
        ...state,
        folderIdToHardDelete: action.payload.folderId,
    }))
    .handle(confirmHardDeleteFolderClickedAction, (state, action) => ({
        ...state,
        folderIdToHardDelete: undefined,
        contactFoldersBeingDeleted: [...state.contactFoldersBeingDeleted, action.payload.folderId],
    }))
    .handle(cancelHardDeleteFolderClickedAction, (state, action) => ({
        ...state,
        folderIdToHardDelete: undefined,
    }))
    .handleDataAction(
        hardDeleteFolderCompletedAction,
        (state, action) => ({
            ...state,
            contactFoldersBeingDeleted: state.contactFoldersBeingDeleted.filter(
                folderId => folderId !== action.payload.folderId
            ),
        }),
        (state, action) => ({
            ...state,
            contactFoldersBeingDeleted: state.contactFoldersBeingDeleted.filter(
                folderId => folderId !== action.payload.folderId
            ),
        })
    )
    .handle(renameFolderEnteredAction, (state, action) => {
        return {
            ...state,
            beingRenamedFolders: state.beingRenamedFolders.concat([
                { folderId: action.payload.folderId, newName: action.payload.newName },
            ]),
        };
    })
    .handleDataAction(
        renameFolderCompletedAction,
        (state, action) => ({
            ...state,
            beingRenamedFolders: state.beingRenamedFolders.filter(
                folder => folder.folderId !== action.payload.folderId
            ),
        }),
        (state, action) => ({
            ...state,
            beingRenamedFolders: state.beingRenamedFolders.filter(
                folder => folder.folderId !== action.payload.folderId
            ),
        })
    )
    .done(defaultState);
export type { Action } from '../../../shared';
